/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-12 09:47:22
 * @LastEditors: K
 * @LastEditTime: 2022-08-04 15:30:25
 */
import React, { ReactElement, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { NotificationCenter } from './NotificationCenter/notificationCenter'
import { SendMessagePage } from './sendMessage/sendMessagePage/sendMessagePage'
import { QAmanagement } from '../QAmanagement/QAmanagement'

export const NotificationStatin = (): ReactElement => {
  const location: any = useLocation()

  const [tabKey, setTabKey] = useState('0')

  return (
    <TabBar
      style={{ margin: '10px 20px' }}
      defaultActiveKey={location.state ? location.state.selectKey : '0'}
      onChange={(v) => {
        setTabKey(v)
      }}
    >
      <TabPane key='0' tab='消息通知'>
        <NotificationCenter tabKey={tabKey} />
      </TabPane>
      <TabPane key='1' tab='短信推送'>
        <SendMessagePage />
      </TabPane>
      <TabPane key='2' tab='QA管理'>
        <QAmanagement />
      </TabPane>
    </TabBar>
  )
}
